// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');

// @ commons
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');

// @ components
const BrokerProductAdvancedSearch = require('components/broker/brokerProductAdvancedSearch/brokerProductAdvancedSearch');
const { BrokerProductFiltersCollapsed } = require('components/broker/brokerProductFiltersCollapsed/brokerProductFiltersCollapsed');
const { BrokerNoStockAccountModal }  = require('components/broker/brokerSearchResults/brokerNoStockAccountModal');
const TutorialLauncher = require('components/tutorial/tutorialLauncher');

// @actions
const BrokerProductAdvancedSearchActions = require('actions/brokerProductAdvancedSearch');
const BrokerProductFiltersSearchActions = require('actions/brokerProductFiltersSearch');
const BrokerAdvancedSearchTaggingActions = require('actions/brokerAdvancedSearchTagging');

const {
    MYPROFILE_BROKER_EXPLORE_URL,
    MYPROFILE_BROKER_URL,
    GRAPHIC_TUTOR_TYPE_15
} = require('constants/index');

class BrokerProductAdvancedSearchResultsView extends React.Component {
    constructor(props) {
        super(props);
        this.breadcrumb = [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: MYPROFILE_BROKER_URL
            },
            {
                text: formatText('brokerAdvancedSearch-brokerAdvancedSearch_advancedSearchName'),
                url: MYPROFILE_BROKER_EXPLORE_URL
            },
            {
                text: formatText(`brokerAdvancedSearch-brokerAdvancedSearch_resultsTitle`),
                url: ''
            }
        ];
        this.state = {
            watchlistTutorialHasBeenShown: false
        }
        this.tutorialCloseCallBack = this.tutorialCloseCallBack.bind(this);
    }

    componentDidMount() {
        const { history, immBrokerProductAdvancedSearch } = this.props;

        if (!immBrokerProductAdvancedSearch.get('fetched') && !immBrokerProductAdvancedSearch.get('isFetching')) {
            history.replace(MYPROFILE_BROKER_EXPLORE_URL);
        }
    }

    tutorialCloseCallBack() {
        const brokerWatchlistTutorialInfo = this.props.immTutorial.get('tutorialList').find(immTutorialDetails =>
            immTutorialDetails.get('tutorial') === `tg-tutorial-${GRAPHIC_TUTOR_TYPE_15}`
        );
        this.setState({
            watchlistTutorialHasBeenShown: !!brokerWatchlistTutorialInfo && !brokerWatchlistTutorialInfo.get('seen')
        });
    }

    buildTutorial() {
        const { immBrokerWatchlist, immFlagBasedFeatures } = this.props;
        const listSelectedIdForParam = immBrokerWatchlist.get('listSelectedIdForParam');
        const watchlistEnabled = immFlagBasedFeatures.get('watchlist-enabled');

        return watchlistEnabled && (
            <TutorialLauncher
                type={GRAPHIC_TUTOR_TYPE_15}
                title={formatText(`tutorials-type${GRAPHIC_TUTOR_TYPE_15}Title`)}
                subtitle={formatText(`tutorials-type${GRAPHIC_TUTOR_TYPE_15}Subtitle`)}
                tooltip={formatText(`tutorials-type${GRAPHIC_TUTOR_TYPE_15}Tooltip`)}
                shouldOpenByDefault={!isNaN(parseInt(listSelectedIdForParam))}
                closeCallBack={this.tutorialCloseCallBack}
            />
        );
    }

    render() {
        const { immStocksContracts } = this.props;
        const tutorial = this.buildTutorial();
        const hasNoStockContracts = immStocksContracts.isEmpty();

        return (
            <div className="container-fluid">
                <div className="row">
                    <OKCover size="medium" section="broker" customClass="col-lg-12">
                        <OKHeaderSubPage
                            breadcrumbConfig={this.breadcrumb}
                            finalTitle={getFinalTitle('brokerAdvancedSearch-brokerAdvancedSearch_resultsTitle')}
                            tutorial={tutorial}
                        />
                    </OKCover>
                </div>
                <div className="row broker-product-advanced-search-view__content">
                    <div className="broker-product-advanced-search">
                        <div className="broker-product-advanced-search__filter--collapsed">
                            <div className="grid-view__body">
                                <BrokerProductFiltersCollapsed editSearch={this.props.editSearch} />
                            </div>
                        </div>
                        <BrokerProductAdvancedSearch
                            immBrokerProductAdvancedSearch={this.props.immBrokerProductAdvancedSearch}
                            advancedSearchProducts={this.props.advancedSearchProducts}
                            searchSpecificProduct={this.props.searchSpecificProduct}
                            searchSpecificProductTracking={this.props.searchSpecificProductTracking}
                            searchWithPage={this.props.searchWithPage}
                            hasNoStockContracts={hasNoStockContracts}
                            editSearch={this.props.editSearch}
                            immBrokerProductFiltersSearch={this.props.immBrokerProductFiltersSearch}
                            retryCombosFilters={this.props.retryCombosFilters}
                            updateFiltersCombosConfiguration={this.props.updateFiltersCombosConfiguration}
                            retryAdvancedSearch={this.props.retryAdvancedSearch}
                            retryAdvancedSearchSpecificProduct={this.props.retryAdvancedSearchSpecificProduct}
                            watchlistTutorialHasBeenShown={this.state.watchlistTutorialHasBeenShown}
                        />
                    </div>
                </div>
                <BrokerNoStockAccountModal/>
            </div>
        );
    }
}

BrokerProductAdvancedSearchResultsView.propTypes = {
    history: PropTypes.object.isRequired,
    immBrokerWatchlist: PropTypes.object.isRequired,
    immBrokerProductAdvancedSearch: PropTypes.object.isRequired,
    immBrokerProductFiltersSearch: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immStocksContracts: PropTypes.object,
    immTutorial: PropTypes.object,
    advancedSearchProducts: PropTypes.func,
    editSearch: PropTypes.func,
    match: PropTypes.object.isRequired,
    searchSpecificProduct: PropTypes.func,
    searchSpecificProductTracking: PropTypes.func,
    searchWithPage: PropTypes.func,
    retryCombosFilters: PropTypes.func,
    updateFiltersCombosConfiguration: PropTypes.func,
    retryAdvancedSearch: PropTypes.func,
    retryAdvancedSearchSpecificProduct: PropTypes.func
};


module.exports.constructor = BrokerProductAdvancedSearchResultsView;
module.exports.BrokerProductAdvancedSearchResultsView = connect(
    state => ({
        immBrokerWatchlist: state.brokerWatchlist,
        immBrokerProductAdvancedSearch: state.brokerProductAdvancedSearch,
        immBrokerProductFiltersSearch: state.brokerProductFiltersSearch,
        immFlagBasedFeatures: state.flagBasedFeatures,
        immStocksContracts: state.brokerStocksContract,
        immTutorial: state.tutorial
    }),{
        getFilters: BrokerProductFiltersSearchActions.getFilters,
        advancedSearchProducts: BrokerProductAdvancedSearchActions.advancedSearchProducts,
        editSearch: BrokerAdvancedSearchTaggingActions.editSearch,
        searchSpecificProduct: BrokerProductAdvancedSearchActions.searchSpecificProduct,
        searchSpecificProductTracking: BrokerAdvancedSearchTaggingActions.searchSpecificProductTracking,
        searchWithPage: BrokerProductAdvancedSearchActions.searchWithPage,
        retryCombosFilters: BrokerProductFiltersSearchActions.retryCombosFilters,
        updateFiltersCombosConfiguration: BrokerProductFiltersSearchActions.updateFiltersCombosConfiguration,
        retryAdvancedSearch: BrokerProductAdvancedSearchActions.retryAdvancedSearch,
        retryAdvancedSearchSpecificProduct: BrokerProductAdvancedSearchActions.retryAdvancedSearchSpecificProduct
    }
)(withRouter(BrokerProductAdvancedSearchResultsView));
